import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

export default class Currency {
  constructor() {
    $('[data-currency-converter]').on('change', event => this.convertAll(event));
  }

  convertAll(event) {
    CurrencyConverter.setCurrency(event.currentTarget.value);
    $('.selected-currency', this.$el).text(event.currentTarget.value);
  }
}
